/* eslint-disable */
<template>
  <div id="loginapp">
    <div class="login" v-if="!sent">
      <div class="form">
        <div>
          <div class="logo" style="text-align:center;">
            <a href="http://fexspace.com"><img src="../../public/logo-small.png" /></a>
          </div>
          <h3 style="text-align:center;">Forgot Password</h3>
          <p style="text-align:center;">Enter your email address to get a reset link</p>
          <form @keypress="send" @submit.prevent>
            <div class="error-login animated slideInUp" v-if="error.message">
              This email does not exist in fexspace
              <i class="fa fa-times" @click="close"></i>
            </div>
            <div>
              <input type="text" placeholder="Email address" v-model="email" />
              <span class="error" v-if="error.email">*Required</span>
            </div>
            <div>
              <button type="button" @click="submit">Send Link</button>
            </div>
            <div class="dont">
              <p>Remember your password? <router-link to="/login">Log In</router-link></p>
            </div>
          </form>
        </div>
      </div>
    </div>
    <div class="sent" v-if="sent">
      <p>
        <a href="http://fexspace.com"><img src="../../public/logo-small.png" /></a>
      </p>
      <p class="link-text">A reset password link has been sent to <strong>{{ email }}</strong></p>
      <p class="request"><router-link to="/login">Go Back</router-link></p>
    </div>
    <loading ref="loading"></loading>
  </div>
</template>
<style scoped>
.login {
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
}
#loginapp {
  justify-content: center;
  align-items: center;
  display: flex;
  height: 100%;
}
.link-text {
  font-family: 'heebo-medium';
}
.request a {
  background: #0d538d;
  color: #fff;
  font-family: 'heebo-medium';
  border-radius: 3px;
  padding: .78em 3em;
}
.request {
  margin-top: 4em;
}
.request a:hover {
  text-decoration: none;
}
.login .form form > div {
    margin-bottom: .9em;
}
</style>
<script>
import AuthenticationService from '../services/AuthenticationService'
import loading from '../components/Loading'
import cookies from '@/services/cookies'
import { mapMutations } from 'vuex'

export default {
  components: {
    loading
  },
  data () {
    return {
      reveal: false,
      email: '',
      sent: false,
      error: {
        email: false,
        message: false
      },
      post: true
    }
  },
  methods: {
    ...mapMutations([
      'SET_DIRECTORY_CHILDREN',
      'SET_IS_SECURITY_QUESTION'
    ]),
    reveal_password () {
      this.reveal = !this.reveal
    },
    close () {
      this.error.message = false
    },
    send (evt) {
      if (evt.keyCode === 13) {
        this.post = true

        if (this.email === '') {
          this.post = false
          this.error.email = true
        } else {
          this.error.email = false
        }

        if (this.post) {
          let that = this
          this.$refs.loading.load()

          let data = {
            email: this.email
          }

          AuthenticationService.forgotpassword(data)
            .then(res => {
              if (res.data.data === true) {
                that.sent = true
                that.$refs.loading.close()
              } else {
                that.$refs.loading.close()
                that.error.message = true
              }
            })
            .catch(err => {
              console.log(err)
            })
        }
      }
    },
    submit () {
      this.post = true

      if (this.email === '') {
        this.post = false
        this.error.email = true
      } else {
        this.error.email = false
      }

      if (this.post) {
        let that = this
        this.$refs.loading.load()

        let data = {
          email: this.email
        }

        AuthenticationService.forgotpassword(data)
          .then(res => {
            if (res.data.data === true) {
              that.sent = true
              that.$refs.loading.close()
            } else {
              that.$refs.loading.close()
              that.error.message = true
            }
          })
          .catch(err => {
            console.log(err)
          })
      }
    }
  },
  mounted () {
    localStorage.removeItem('current_directory_id')
    localStorage.removeItem('db')
    if (cookies.getCookie('token') !== '' && cookies.getCookie('token') !== null) {
      if (sessionStorage.getItem('status') === 'true') {
        this.$router.push('/')
      }
    }

    this.SET_DIRECTORY_CHILDREN([])
  }
}
</script>
